export default {
  name: 'vscroll',
  version: '1.7.0'
};
